import classNames from 'classnames';

import { UserRequestStatus } from '@/shared/types';

import { StatusDecorator } from '@/api/types';

import { Typography, Icon } from '../';

import './Status.scss';

type Status = UserRequestStatus | Omit<StatusDecorator, 'message_icon' | 'message_color'>;

interface Props {
  status: Status;
  classname?: string;
}

const statusStrategy = (status: Status): Omit<StatusDecorator, 'message_icon' | 'message_color'> => {
  switch (status) {
    case UserRequestStatus.DRAFT: {
      return {
        name: 'Чернетка',
        color: 's-asphalte',
        text_color: 'white',
        icon: 'draft',
      };
    }
    case UserRequestStatus.IN_PROCESS: {
      return {
        name: 'В обробці',
        color: 's-orange',
        text_color: 'black',
        icon: 'waiting',
      };
    }
    case UserRequestStatus.READY_TO_SEND: {
      return {
        name: 'Формування документів',
        color: 's-steel',
        text_color: 'white',
        icon: 'ready_to_send',
      };
    }
    case UserRequestStatus.PAYMENT: {
      return {
        name: 'Очікує на оплату',
        color: 's-carrot',
        text_color: 'white',
        icon: 'attention',
      };
    }
    case UserRequestStatus.FINISHED: {
      return {
        name: 'Обробка закінчена',
        color: 's-grass',
        text_color: 'white',
        icon: 'check',
      };
    }

    default:
      return status;
  }
};

export const Status: React.FC<Props> = ({ status, classname = '' }) => {
  if (!status) return null;

  const { name, color, text_color, icon } = statusStrategy(status);

  return (
    <div className={classNames('custom-status', classname)} style={{ backgroundColor: `var(--${color})` }}>
      {icon && (
        <div className="custom-status__icon">
          <Icon name={icon} color={text_color} width={16} height={16} />
        </div>
      )}
      <Typography variant="TEXT14" className="custom-status__message" color={text_color}>
        {name}
      </Typography>
    </div>
  );
};
